var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVidColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#4AB3E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1281 10.5H13.3089C10.3332 10.5 7.875 12.9582 7.875 15.9339V25.2491C7.875 28.2248 10.3332 30.683 13.3089 30.683H29.9987C32.9744 30.683 35.4326 28.2248 35.4326 25.2491V15.9339C35.562 12.9582 33.1038 10.5 30.1281 10.5ZM32.9744 25.3785C32.9744 26.9311 31.6806 28.2248 30.1281 28.2248H13.3089C11.7564 28.2248 10.4626 26.9311 10.4626 25.3785V16.0633C10.4626 14.5107 11.7564 13.2169 13.3089 13.2169H29.9987C31.5513 13.2169 32.845 14.5107 32.845 16.0633V25.3785H32.9744Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7777 16.5809C19.2602 16.3221 18.7427 16.7103 18.7427 17.2278V24.3436C18.7427 24.8611 19.3896 25.2493 19.7777 24.9905L25.9879 21.4973C26.5054 21.2385 26.5054 20.5916 25.9879 20.3329L19.7777 16.5809Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVidColor);
export default __webpack_public_path__ + "static/media/vid_color.6e7b29859ea44abb44c6ba7595b589cd.svg";
export { ForwardRef as ReactComponent };